export enum PAX_TYPE {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  BABY = 'BABY',
}

export type PaxType = (typeof PAX_TYPE)[keyof typeof PAX_TYPE];
